import { render, staticRenderFns } from "./DataReport.vue?vue&type=template&id=457b5ce4&scoped=true"
import script from "./DataReport.vue?vue&type=script&lang=js"
export * from "./DataReport.vue?vue&type=script&lang=js"
import style0 from "./DataReport.vue?vue&type=style&index=0&id=457b5ce4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b5ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457b5ce4')) {
      api.createRecord('457b5ce4', component.options)
    } else {
      api.reload('457b5ce4', component.options)
    }
    module.hot.accept("./DataReport.vue?vue&type=template&id=457b5ce4&scoped=true", function () {
      api.rerender('457b5ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/dataReport/DataReport.vue"
export default component.exports